(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/deposit/do-deposit.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/deposit/do-deposit.js');

'use strict';

const logger = svs.arena.logger;
const {
  depositType,
  returnStatus
} = svs.arena.constants;
const {
  postDepositToTeamAsync
} = svs.arena.service.transferService;
const {
  showDepositDialog,
  showDepositOkDialog,
  showDepositLimitNotSet,
  showDepositInviteDialog,
  showBalanceTooLowDialog,
  showDepositCreateDialog,
  showDepositErrorDialog,
  showDepositBlockedUserDialog
} = svs.arena.shared.deposit.depositDialogs;
const getBalance = async () => {
  const balance = await new Promise(resolve => {
    svs.components.account_balance.get(accountBalance => {
      resolve(accountBalance);
    });
  });
  return balance;
};
const navigateOutsideArena = async (amount, syndicateId, depositType, urlToNavigate) => new Promise(resolve => {
  svs.components.Storage.browser.set('syndicateDepositAmount', 'syndicate', {
    amount,
    syndicateId,
    depositType
  }, svs.components.Storage.constants.EXPIRES_10M, () => {
    svs.utils.form.postToUrl(urlToNavigate, {
      returnUrl: svs.core.urlMapping.get('playTogetherTeams')
    });
    resolve();
  });
});
const hasBalance = async amount => {
  let hasMoney = true;
  const balance = await getBalance();
  const parsedAccountBalance = parseInt(balance, 10);
  const parsedDepositAmount = parseInt(amount, 10);
  if (parsedAccountBalance < parsedDepositAmount) {
    hasMoney = false;
  }
  return {
    hasMoney,
    balance
  };
};
const trackDeposit = (type, cancel) => {
  const track = {
    category: 'spela-tillsammans',
    action: 'deposit_teamaccount',
    opt_label: cancel ? "".concat(type, "_cancel") : type
  };
  svs.components.analytics.trackEvent(track);
};
const trackAddToBalanceDeposit = function (type, cancel) {
  let callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
  const track = {
    category: 'spela-tillsammans',
    action: 'deposit_teamaccount',
    opt_label: cancel ? "".concat(type, "_add_balance_cancel") : "".concat(type, "_add_balance")
  };
  svs.components.analytics.trackEvent(track, callback);
};
const doDeposit = async (amount, teamId, depositType) => {
  const {
    data,
    error
  } = await postDepositToTeamAsync(amount, teamId);
  if (error) {
    switch (error.code) {
      case '6 289':
        if (await showDepositLimitNotSet()) {
          await navigateOutsideArena(amount, teamId, depositType, svs.core.urlMapping.get('myLimitsAllDeposits'));
        } else {
          return {
            status: returnStatus.CANCEL
          };
        }
        break;
      case '6 149':
        await showDepositBlockedUserDialog();
        return {
          status: returnStatus.ERROR
        };
      case '6 336':
        svs.accountservices.day_time_limit.notices.depositSyndicate();
        return {
          status: returnStatus.ERROR
        };
      case '5 139':
        svs.tur.apierrors.showErrorMessage({
          response: 5139
        });
        return {
          status: returnStatus.ERROR
        };
      default:
        await showDepositErrorDialog();
        return {
          status: returnStatus.ERROR
        };
    }
  } else {
    trackDeposit(depositType, false);
    svs.components.account_balance.set(data.playerAccountBalance);
    return {
      status: returnStatus.SUCCESS,
      memberBalance: data.memberBalance,
      syndicateBalance: data.syndicateBalance,
      playableAmount: data.playableAmount
    };
  }
};
const specialDepositFlow = async (amount, teamId, depositType) => {
  const {
    hasMoney,
    balance
  } = await hasBalance(amount);
  if (hasMoney) {
    return await doDeposit(amount, teamId, depositType);
  } else if (await showBalanceTooLowDialog(balance, amount)) {
    trackAddToBalanceDeposit(depositType, false, await navigateOutsideArena(amount, teamId, depositType, svs.core.urlMapping.get('transactionsHome')));
  } else {
    trackAddToBalanceDeposit(depositType, true);
    return {
      status: returnStatus.CANCEL
    };
  }
};
const normalDepositFlow = async (amount, teamId, depositType) => {
  const depositData = await doDeposit(amount, teamId, depositType);
  if (depositData.status === returnStatus.SUCCESS) {
    await showDepositOkDialog(amount);
  }
  return depositData;
};
const depositError = async () => {
  logger.warn('Something is wrong with amount when invite deposit');
  await showDepositErrorDialog();
  return {
    status: returnStatus.ERROR
  };
};

const submitDeposit = async (amount, teamId) => {
  const type = depositType.DIRECT;
  if (amount !== '' && parseInt(amount, 10) > 0) {
    const {
      hasMoney,
      balance
    } = await hasBalance(amount);
    if (hasMoney) {
      if (await showDepositDialog(amount)) {
        return await normalDepositFlow(amount, teamId, type);
      }
      trackDeposit(type, true);
      return {
        status: returnStatus.CANCEL
      };
    } else if (await showBalanceTooLowDialog(balance, amount)) {
      trackAddToBalanceDeposit(type, false, await navigateOutsideArena(amount, teamId, type, svs.core.urlMapping.get('transactionsHome')));
    } else {
      trackAddToBalanceDeposit(type, true);
      return {
        status: returnStatus.CANCEL
      };
    }
  } else {
    depositError();
  }
};

const submitCreateDeposit = async (amount, teamId) => {
  const type = depositType.CREATE;
  if (amount !== '' && parseInt(amount, 10) > 0) {
    if (await showDepositCreateDialog(amount)) {
      return specialDepositFlow(amount, teamId, type);
    }
    trackDeposit(type, true);
    return {
      status: returnStatus.CANCEL
    };
  }
  depositError();
};

const submitInviteDeposit = async (amount, teamId) => {
  const type = depositType.INVITE;
  if (amount !== '' && parseInt(amount, 10) > 0) {
    if (await showDepositInviteDialog(amount)) {
      return specialDepositFlow(amount, teamId, type);
    }
    trackDeposit(type, true);
    return {
      status: returnStatus.CANCEL
    };
  }
  depositError();
};
svs.arena.shared.deposit.doDeposit = {
  submitDeposit,
  submitInviteDeposit,
  submitCreateDeposit
};

 })(window);